import React from 'react';
import { IValidationToastNotification } from '../../common';
import { v4 as uuidv4 } from 'uuid';
import { MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export interface ICustomerValidationWarningProps extends IValidationToastNotification {
  fields: string[];
}

export const CustomerValidationWarning = (props: ICustomerValidationWarningProps) => {
  const fields = props.fields;
  return (
    <div className="w-[55rem] relative top-auto -bottom-[45rem] left-1/2 -translate-x-1/2">
      <MessageBar severity={TMessageBarSeverity.ERROR} onClose={props?.onClose} dismissible>
        <h4 className="text-lg/[175%]">Mangler kundeinformasjon</h4>
        <ul>
          {fields?.map((name) => (
            <li key={uuidv4()} className="text-base/[175%] font-semibold">
              {name}
            </li>
          ))}
        </ul>
      </MessageBar>
    </div>
  );
};
